import i18n from "~/plugins/i18n";
export default {
    fields: [
        {
            key: "input",
            label: "Input",
            sorter: false,
            active: true,
            filter: false,
            _filter: true,
            _style: "width:15%",
        },
        {
            key: "provider",
            label: "Provider",
            sorter: true,
            active: true,
            filter: false,
            _filter: true,
            _style: "width:10%"
        },
        {
            key: "origin",
            label: "Origin",
            sorter: true,
            active: true,
            filter: false,
            _filter: true
        },
        {
            key: "id_output",
            label: "Id Output",
            sorter: true,
            active: true,
            filter: false,
            _filter: true
        },
        {
            key: "output",
            label: "Output",
            sorter: true,
            active: true,
            filter: false,
            _filter: true,
            _style: "width:20%"
        },
        {
            key: "country_id",
            label: "country",
            sorter: true,
            active: true,
            filter: false,
            _filter: {
                active: false,
                value: null,
                condition: "is_equal_to",
                type: "select",
                options: [
                    { value: "999", label: i18n.t("spain") },
                    { value: "380", label: i18n.t("italy") },
                ],
            }
        },
        {
            key: "Sents",
            label: "Sent",
            sorter: true,
            active: true,
            filter: false,
            _filter: false
        },
        {
            key: "ok",
            label: "Ok",
            sorter: true,
            active: true,
            filter: false,
            _filter: false
        },
        {
            key: "status_percentOk",
            label: "ok_(%)",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
            _style: "width:5%"
        },
        {
            key: "ko",
            label: "Ko",
            sorter: true,
            active: true,
            filter: false,
            _filter: false
        },
        {
            key: "status_percentKo",
            label: "ko_(%)",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
            _style: "width:5%"
        },
        {
            key: "duplicate",
            label: "Duplicate",
            sorter: true,
            active: true,
            filter: false,
            _filter: false
        },
        {
            key: "status_percentDuplication",
            label: "duplicates_(%)",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
            _style: "width:5%"
        },
        {
            key: "error",
            label: "Error",
            sorter: true,
            active: true,
            filter: false,
            _filter: false
        },
        {
            key: "status_percentError",
            label: "error_(%)",
            sorter: true,
            active: true,
            filter: false,
            _filter: false,
            _style: "width:5%"
        },
        {
            key: "sale_price",
            label: "Precio Venta",
            sorter: true,
            active: true,
            filter: false,
            _filter: false
        },
        {
            key: "total_sale",
            label: "Ganancia",
            sorter: true,
            filter: false,
            active: true,
            _filter: false,
            _style: "width:5%"
        }
    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 5,
    page: 1,
    total_pages: 1,
    loading: true,
    hover: true,
    pagination: true,
    sorter: {
        external: true,
        resetable: true
    },
    sorterValue: {
        asc: true,
        column: "input"
    },
    size: "sm",
    columnFilter: true,
    itemsPerPageSelect: true,
    export: null,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {}
}